import {
  TransferBgEth,
  TransferBgTrx,
  TransferBgBtc,
  TransferBgUni,
  // toaster,
} from '@halo/ui-chat-react';
import type { User, SessionStore } from '@halo/chat-sdk-react';
import { ChainType } from '@halo/wallet-app';
import { useActionsStore } from '@/store/actions';

export const useContactsHandler = (user: User | null) => {
  const setMyContactSettingIsOpen = useActionsStore((store) => store.setMyContactSettingIsOpen);

  const onBlockContacts = useCallback(async () => {
    // await client?.Api.contacts.contactsBlock(user_id);
  }, []);

  const onAddContacts = useCallback(async () => {
    setMyContactSettingIsOpen(true, user ?? null);
    // await client?.Api.contacts.contactsAdd(user.user_id);
    // toaster.success({
    //   title: 'Add contact successfully',
    // });
  }, [setMyContactSettingIsOpen, user]);

  return {
    onBlockContacts,
    onAddContacts,
  };
};

export interface EditorContextWithStateProps {
  children: ReactNode;
  sessionStore?: SessionStore;
}

export const getTransferBgImg = (chainType: string) => {
  switch (chainType) {
    case ChainType.EVM:
      return `url(${TransferBgEth})`;
    case ChainType.Tron:
      return `url(${TransferBgTrx})`;
    case ChainType.BTC:
      return `url(${TransferBgBtc})`;
    default:
      return `url(${TransferBgUni})`;
  }
};

interface RGB {
  r: number;
  g: number;
  b: number;
}

export function hexToRgb(hex: string, alpha?: number): RGB {
  hex = hex.replace(/^#/, '');

  if (!/^[0-9A-Fa-f]{3,8}$/.test(hex)) {
    return {
      r: 255,
      g: 255,
      b: 255,
    };
  }
  if (hex.length === 3 || hex.length === 4) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  if (alpha !== undefined) {
    const normalizedAlpha = Math.max(0, Math.min(1, alpha));
    r = Math.round(r * normalizedAlpha + 255 * (1 - normalizedAlpha));
    g = Math.round(g * normalizedAlpha + 255 * (1 - normalizedAlpha));
    b = Math.round(b * normalizedAlpha + 255 * (1 - normalizedAlpha));
  }
  return { r, g, b };
}
